module.exports = __webpack_public_path__ + "img/info-security.f005f49b.png";